<!-- Professional Load Balancers Hero Section -->
<section class="professional-hero-section">
    <div class="container">
        <div class="row align-items-center min-vh-100">
            <div class="col-lg-6 col-md-12">
                <div class="hero-content">
                    <!-- Company Badge -->
                    <div class="company-badge mb-4">
                        <span class="badge-professional">
                            <i class="bx bx-shield-check"></i> 
                            Enterprise Load Balancing Solutions
                        </span>
                    </div>
                    
                    <!-- Hero Title -->
                    <h1 class="hero-title-professional mb-4">
                        Intelligent Traffic Management
                        <span class="text-highlight">for Modern Applications</span>
                    </h1>
                    
                    <!-- Hero Description -->
                    <p class="hero-description-professional mb-4">
                        Distribute traffic intelligently across multiple servers with enterprise-grade load balancing solutions. 
                        Ensure high availability, automatic failover, and optimal performance for your mission-critical applications.
                    </p>
                    
                    <!-- Key Benefits -->
                    <div class="key-benefits mb-4">
                        <div class="benefit-item">
                            <i class="bx bx-check-circle"></i>
                            <span>99.99% Uptime SLA Guarantee</span>
                        </div>
                        <div class="benefit-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Contact us for pricing details - Pay as you use</span>
                        </div>
                        <div class="benefit-item">
                            <i class="bx bx-check-circle"></i>
                            <span>24/7 Expert Support Team</span>
                        </div>
                    </div>
                    
                    <!-- Professional Actions -->
                    <div class="hero-actions-professional mb-4">
                        <a routerLink="/contact" class="btn-professional-primary">
                            <i class="bx bx-phone"></i> Contact Sales Team
                        </a>
                        <a routerLink="/contact" class="btn-professional-secondary">
                            <i class="bx bx-message-dots"></i> Request Consultation
                        </a>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-6 col-md-12">
                <div class="hero-visual-professional">
                    <div class="visual-container">
                        <img src="assets/img/load-balancer-hero.png" alt="Load Balancers" class="hero-image-professional">
                        
                        <!-- Professional Info Cards -->
                        <div class="info-card card-traffic">
                            <div class="card-icon">
                                <i class="bx bx-sitemap"></i>
                            </div>
                            <div class="card-info">
                                <div class="card-value">Intelligent</div>
                                <div class="card-label">Traffic Routing</div>
                            </div>
                        </div>
                        
                        <div class="info-card card-health">
                            <div class="card-icon">
                                <i class="bx bx-health"></i>
                            </div>
                            <div class="card-info">
                                <div class="card-value">Real-time</div>
                                <div class="card-label">Health Checks</div>
                            </div>
                        </div>
                        
                        <div class="info-card card-security">
                            <div class="card-icon">
                                <i class="bx bx-lock-alt"></i>
                            </div>
                            <div class="card-info">
                                <div class="card-value">SSL/TLS</div>
                                <div class="card-label">Termination</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Modern Services Section -->
<section class="modern-services-section">
    <div class="container">
        <!-- Section Header -->
        <div class="section-header text-center mb-5">
            <div class="section-badges mb-3">
                <span class="section-badge"><i class="bx bx-layer"></i> Load Balancer Solutions</span>
            </div>
            <h2 class="section-title mb-4">
                Choose Your <span class="text-gradient">Load Balancing Solution</span>
            </h2>
            <p class="section-description mx-auto">
                Select from our comprehensive range of load balancing solutions designed for different application architectures 
                and performance requirements.
            </p>
        </div>
        
        <!-- Services Grid -->
        <div class="services-grid">
            <div class="row g-4">
                <!-- Application Load Balancer -->
                <div class="col-lg-4 col-md-6">
                    <div class="service-card h-100">
                        <div class="service-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-layer"></i>
                            </div>
                        </div>
                        <div class="service-content">
                            <div class="lb-type-badge popular mb-3">Popular</div>
                            <h3 class="mb-3">Application Load Balancer</h3>
                            <p class="mb-3">Layer 7 load balancing with advanced routing, SSL termination, and application-aware traffic distribution for modern web applications.</p>
                            <div class="service-features mb-3">
                                <span class="feature-tag">HTTP/HTTPS</span>
                                <span class="feature-tag">Path-based</span>
                                <span class="feature-tag">SSL Termination</span>
                            </div>
                            <div class="pricing-modern mb-3">
                                <span class="price-text">Contact us for</span>
                                <span class="price-amount">pricing details</span>
                            </div>
                            <a routerLink="/contact" class="btn-service-primary w-100">
                                <i class="bx bx-phone"></i> Contact Sales
                            </a>
                        </div>
                    </div>
                </div>
                
                <!-- Network Load Balancer -->
                <div class="col-lg-4 col-md-6">
                    <div class="service-card h-100">
                        <div class="service-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-network-chart"></i>
                            </div>
                        </div>
                        <div class="service-content">
                            <div class="lb-type-badge performance mb-3">Performance</div>
                            <h3 class="mb-3">Network Load Balancer</h3>
                            <p class="mb-3">Layer 4 load balancing with ultra-low latency and high throughput for TCP/UDP traffic and latency-sensitive applications.</p>
                            <div class="service-features mb-3">
                                <span class="feature-tag">TCP/UDP</span>
                                <span class="feature-tag">Low Latency</span>
                                <span class="feature-tag">High Throughput</span>
                            </div>
                            <div class="pricing-modern mb-3">
                                <span class="price-text">Contact us for</span>
                                <span class="price-amount">pricing details</span>
                            </div>
                            <a routerLink="/contact" class="btn-service-primary w-100">
                                <i class="bx bx-phone"></i> Contact Sales
                            </a>
                        </div>
                    </div>
                </div>
                
                <!-- Global Load Balancer -->
                <div class="col-lg-4 col-md-6">
                    <div class="service-card h-100">
                        <div class="service-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-globe"></i>
                            </div>
                        </div>
                        <div class="service-content">
                            <div class="lb-type-badge global mb-3">Global</div>
                            <h3 class="mb-3">Global Load Balancer</h3>
                            <p class="mb-3">Multi-region traffic distribution with intelligent routing, disaster recovery, and global failover capabilities.</p>
                            <div class="service-features mb-3">
                                <span class="feature-tag">Geo-routing</span>
                                <span class="feature-tag">Failover</span>
                                <span class="feature-tag">Multi-region</span>
                            </div>
                            <div class="pricing-modern mb-3">
                                <span class="price-text">Contact us for</span>
                                <span class="price-amount">pricing details</span>
                            </div>
                            <a routerLink="/contact" class="btn-service-primary w-100">
                                <i class="bx bx-phone"></i> Contact Sales
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Modern Features Section -->
<section class="modern-features-section">
    <div class="container">
        <div class="section-header text-center mb-5">
            <div class="section-badges mb-3">
                <span class="section-badge"><i class="bx bx-cog"></i> Advanced Capabilities</span>
            </div>
            <h2 class="section-title mb-4">
                Load Balancing <span class="text-gradient">Capabilities</span>
            </h2>
            <p class="section-description mx-auto">
                Enterprise-grade features designed for high availability, security, and optimal performance of your applications and services.
            </p>
        </div>
        
        <div class="features-grid">
            <div class="row g-4">
                <!-- Health Checks -->
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card h-100">
                        <div class="feature-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-health"></i>
                            </div>
                        </div>
                        <h3 class="mb-3">Health Checks</h3>
                        <p class="mb-3">Automated health monitoring with configurable check intervals, failure thresholds, and automatic recovery for optimal service availability.</p>
                        <div class="feature-list">
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>HTTP/HTTPS health checks</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>TCP health monitoring</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Custom health endpoints</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Automatic failover</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- SSL/TLS Termination -->
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card h-100">
                        <div class="feature-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-lock-alt"></i>
                            </div>
                        </div>
                        <h3 class="mb-3">SSL/TLS Termination</h3>
                        <p class="mb-3">Comprehensive SSL/TLS management with certificate provisioning, automatic renewal, and perfect forward secrecy for secure communications.</p>
                        <div class="feature-list">
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Free SSL certificates</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Custom certificate support</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Perfect forward secrecy</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>TLS 1.2/1.3 support</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Auto Scaling -->
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card h-100">
                        <div class="feature-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-trending-up"></i>
                            </div>
                        </div>
                        <h3 class="mb-3">Auto Scaling</h3>
                        <p class="mb-3">Dynamic scaling based on traffic patterns, CPU utilization, and custom metrics with predictive scaling and scheduled scaling options.</p>
                        <div class="feature-list">
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Automatic capacity adjustment</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Predictive scaling</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Custom metrics support</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Scheduled scaling</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Load Balancing Algorithms -->
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card h-100">
                        <div class="feature-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-shuffle"></i>
                            </div>
                        </div>
                        <h3 class="mb-3">Load Balancing Algorithms</h3>
                        <p class="mb-3">Multiple distribution algorithms including round-robin, least connections, IP hash, and weighted routing for optimal traffic distribution.</p>
                        <div class="feature-list">
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Round-robin distribution</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Least connections</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>IP hash routing</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Weighted algorithms</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Real-time Monitoring -->
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card h-100">
                        <div class="feature-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-analyse"></i>
                            </div>
                        </div>
                        <h3 class="mb-3">Real-time Monitoring</h3>
                        <p class="mb-3">Comprehensive monitoring with real-time metrics, custom dashboards, alerting, and detailed traffic analysis for performance optimization.</p>
                        <div class="feature-list">
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Real-time metrics</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Custom dashboards</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Alert notifications</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Traffic analytics</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- API & Automation -->
                <div class="col-lg-4 col-md-6">
                    <div class="feature-card h-100">
                        <div class="feature-icon mb-4">
                            <div class="icon-background">
                                <i class="bx bx-code"></i>
                            </div>
                        </div>
                        <h3 class="mb-3">API & Automation</h3>
                        <p class="mb-3">Comprehensive REST APIs, Infrastructure as Code support, and automation tools for seamless integration with your CI/CD pipelines.</p>
                        <div class="feature-list">
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>RESTful APIs</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Terraform support</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>CI/CD integration</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-check"></i>
                                <span>Webhook notifications</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Use Cases Section -->
<section class="use-cases-section">
    <div class="container">
        <div class="section-header text-center mb-5">
            <div class="section-badges mb-3">
                <span class="section-badge"><i class="bx bx-bulb"></i> Application Scenarios</span>
            </div>
            <h2 class="section-title mb-4">
                Load Balancer <span class="text-gradient">Use Cases</span>
            </h2>
            <p class="section-description mx-auto">
                Discover how our load balancing solutions enhance application availability, performance, and scalability across various use cases and industries.
            </p>
        </div>
        
        <div class="use-cases-grid">
            <div class="row g-4">
                <!-- Web Applications -->
                <div class="col-lg-6 col-md-6">
                    <div class="use-case-card primary h-100">
                        <div class="use-case-header mb-3">
                            <div class="use-case-icon me-3">
                                <i class="bx bx-world"></i>
                            </div>
                            <div class="use-case-category">Web Applications</div>
                        </div>
                        <h3 class="mb-3">High-Traffic Websites</h3>
                        <p class="mb-4">Scale web applications seamlessly with intelligent traffic distribution, SSL termination, and automatic failover for millions of concurrent users.</p>
                        
                        <div class="use-case-features mb-4">
                            <div class="feature-list">
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Traffic distribution across servers</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>SSL certificate management</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Session persistence</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Geographic routing</span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="use-case-stats">
                            <div class="stat-item">
                                <div class="stat-number">10M+</div>
                                <div class="stat-label">Concurrent Users</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">99.99%</div>
                                <div class="stat-label">Uptime</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- API Gateway -->
                <div class="col-lg-6 col-md-6">
                    <div class="use-case-card secondary h-100">
                        <div class="use-case-header mb-3">
                            <div class="use-case-icon me-3">
                                <i class="bx bx-mobile-alt"></i>
                            </div>
                            <div class="use-case-category">Mobile & API</div>
                        </div>
                        <h3 class="mb-3">API Gateway</h3>
                        <p class="mb-4">Optimize API performance with intelligent routing, rate limiting, authentication, and real-time monitoring for mobile and web applications.</p>
                        
                        <div class="use-case-features mb-4">
                            <div class="feature-list">
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>API traffic management</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Rate limiting & throttling</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Authentication integration</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Response caching</span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="use-case-stats">
                            <div class="stat-item">
                                <div class="stat-number">1B+</div>
                                <div class="stat-label">API Calls/Day</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">< 50ms</div>
                                <div class="stat-label">Response Time</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Gaming Applications -->
                <div class="col-lg-6 col-md-6">
                    <div class="use-case-card tertiary h-100">
                        <div class="use-case-header mb-3">
                            <div class="use-case-icon me-3">
                                <i class="bx bx-game"></i>
                            </div>
                            <div class="use-case-category">Gaming</div>
                        </div>
                        <h3 class="mb-3">Gaming Applications</h3>
                        <p class="mb-4">Ultra-low latency load balancing for multiplayer games with session affinity, real-time traffic routing, and global server distribution.</p>
                        
                        <div class="use-case-features mb-4">
                            <div class="feature-list">
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Ultra-low latency routing</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Session affinity</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Global server pools</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Real-time monitoring</span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="use-case-stats">
                            <div class="stat-item">
                                <div class="stat-number">< 10ms</div>
                                <div class="stat-label">Latency</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">24/7</div>
                                <div class="stat-label">Availability</div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Enterprise Applications -->
                <div class="col-lg-6 col-md-6">
                    <div class="use-case-card quaternary h-100">
                        <div class="use-case-header mb-3">
                            <div class="use-case-icon me-3">
                                <i class="bx bx-building"></i>
                            </div>
                            <div class="use-case-category">Enterprise</div>
                        </div>
                        <h3 class="mb-3">Enterprise Applications</h3>
                        <p class="mb-4">Mission-critical enterprise applications with high availability, disaster recovery, and compliance features for business continuity.</p>
                        
                        <div class="use-case-features mb-4">
                            <div class="feature-list">
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Multi-region deployment</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Disaster recovery</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Compliance monitoring</span>
                                </div>
                                <div class="feature-item">
                                    <i class="bx bx-check"></i>
                                    <span>Enterprise security</span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="use-case-stats">
                            <div class="stat-item">
                                <div class="stat-number">RTO < 5min</div>
                                <div class="stat-label">Recovery Time</div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-number">SOC 2</div>
                                <div class="stat-label">Compliant</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Professional CTA Section -->
<section class="professional-cta-section">
    <div class="container">
        <div class="cta-content-wrapper">
            <div class="row align-items-center">
                <div class="col-lg-8">
                    <div class="cta-content">
                        <h2 class="mb-4">Ready to Scale Your Applications?</h2>
                        <p class="cta-description mb-4">
                            Deploy intelligent load balancing solutions that ensure high availability, optimal performance, 
                            and seamless user experience. Start with our enterprise-grade load balancers today.
                        </p>
                        
                        <div class="cta-features">
                            <div class="feature-item">
                                <i class="bx bx-rocket"></i>
                                <span>Deploy in 5 minutes</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-support"></i>
                                <span>24/7 Expert Support</span>
                            </div>
                            <div class="feature-item">
                                <i class="bx bx-phone"></i>
                                <span>Contact us for pricing details</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="cta-actions">
                        <a class="btn-cta-primary mb-3" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            <span>Contact Sales Team</span>
                            <small>Get pricing information</small>
                        </a>
                        <a class="btn-cta-secondary" routerLink="/contact">
                            <i class="bx bx-message-dots"></i>
                            <span>Request Consultation</span>
                            <small>Get custom solutions</small>
                        </a>
                        
                        <div class="cta-guarantee mt-4">
                            <div class="guarantee-card">
                                <div class="guarantee-icon">
                                    <i class="bx bx-shield-check"></i>
                                </div>
                                <div class="guarantee-content">
                                    <h4>99.99% Uptime SLA</h4>
                                    <p>Guaranteed availability with automatic failover</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>